import React from "react";
import {PillButton} from "./PillButton";
import {Modal} from "./Modal";

export let ConfirmCancelModal = function (props) {
    let modalBody = null;
    if (Array.isArray(props.warningMessage)) {
        let modalBodyMessages = [];
        for (let i = 0; i < props.warningMessage.length; i++) {
            let message = props.warningMessage[i];
            modalBodyMessages.push(
                <div key={i} className="confirm-cancel-modal-message">
                    {message}
                </div>
            )
        }
        modalBody = (
            <div className="confirm-cancel-modal-body">
                {modalBodyMessages}
            </div>
        )
    } else {
        modalBody = (
            <div className="confirm-cancel-modal-body">
                {props.warningMessage}
            </div>
        )
    }
    return (
        <Modal
            boxClass="confirm-cancel-modal"
            headerText={props.headerText}
            onClickCloseOption={props.cancel}
        >
            {modalBody}

            <div className="confirm-cancel-modal-options">
                <div className="confirm-cancel-modal-option">
                    <PillButton
                        onClick={props.cancel}
                        buttonClasses="confirm-cancel-modal-button confirm-cancel-modal-cancel-button"
                        buttonText="CANCEL"
                        buttonTextClasses="confirm-cancel-modal-button-text"
                    />
                </div>
                <div className="confirm-cancel-modal-option">
                    <PillButton
                        onClick={props.confirm}
                        buttonClasses="confirm-cancel-modal-button confirm-cancel-modal-confirm-button"
                        buttonText={props.confirmButtonText}
                        buttonTextClasses="confirm-cancel-modal-button-text"
                    />
                </div>
            </div>
        </Modal>
    );
};

